module.exports = __webpack_public_path__ + "img/Ativo 2-8.177d11d1.png";